module.exports = __webpack_public_path__ + "v4assets/silver-peak-logo.427833adc8aafef8b1271a87fdc6d864.png";